import React from 'react';
import dashboardBackground from 'assets/images/dashboard-background.png';
import MainLayout from 'components/layout/MainLayout';
import { ButtonTypes } from 'types';
import { RouteSource } from '@monorepo/shared/src/graph/schema-generated-types-student';

type Props = {
  tiles: any;
};

const Home: React.FC<Props> = ({ tiles }) => {
  return (
    <MainLayout
      backgroundImg={dashboardBackground}
      menuProps={{
        primaryRightButton: { name: ButtonTypes.REWARD_BUTTON },
      }}
      footerProps={{
        primaryLeftButton: { name: ButtonTypes.MAT_MAN_BUTTON, from: RouteSource.DASHBOARD },
        primaryRightButton: { name: ButtonTypes.LOGOUT_BUTTON },
        secondaryRightButton: { name: ButtonTypes.FOR_FAMILIES_BUTTON },
      }}
    >
      {tiles.map(({ Component, title, onClick, styles, components, ...rest }) => (
        <Component
          key={title}
          onClick={onClick}
          styles={styles}
          components={components}
          {...rest}
        />
      ))}
    </MainLayout>
  );
};

export default Home;
